import React from 'react';
import { List } from './List';

export interface ItemComponentProps {
  image: string;
  title: string;
  shortDescription: string;
  date: string;
  identifier: string;
  url: string;
}

export interface ContentProps {
  url: string;
  items: ItemComponentProps[];
  page: number;
  pages: number;
  total: number;
  size: number;
}
export const ItemComponent: React.FC<ItemComponentProps> = ({
  url, image, title, shortDescription, date, identifier,
}) => {
  const localDate = new Date(date).toLocaleDateString('pl-PL');
  const slug = `${localDate.split('.').map((datePart) => datePart.padStart(2, '0')).reverse().join('/')}/${identifier}`;
  return (
    <div className="articles-item">
      <a href={`${url}/${slug}`}>
        { image ? <img alt={`${title} - zdjęcie`} src={image} className="articles-thumbnail" /> : <div className="articles-thumbnail" />}
        <div className="articles__description">
          <div className="articles-title">{title || "Coś poszło nie tak, sprawdź później"}</div>
          <div className="articles-short">{shortDescription}</div>
          <div className="articles__date-more">
            { date && <div className="articles-date">{localDate}</div> }
            <div className="articles-more">{title && "CZYTAJ DALEJ"}</div>
          </div>
        </div>
      </a>
    </div>
  );
};

export const Articles: React.FC<ContentProps> = (props) => (
  <List
    ItemComponent={ItemComponent}
    className="articles-list"
    {...props}
  />
);
